import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AuthService } from '../../../services/auth.service';
import { Utilities } from '../../../services/utilities';
import { User } from '../../../models/user.model';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-account-search',
  templateUrl: './account-search.component.html',
  styleUrls: ['./account-search.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterLink,
    CommonModule
  ]
})
export class AccountSearchComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  columnNames = ['firstName', 'lastName', 'email', 'isEnabled', 'roles'];
  userSource: MatTableDataSource<User>;
  pageSize: number = 25;
  pageIndex: number = 0;
  private _formatRolesDict = {
    'admin': 'Admin',
    'QCCoder': 'QC Coder',
    'QCSupervisor': 'QC Supervisor',
    'ReconciliationCoder': 'Reconciliation Coder',
    'ReconciliationSupervisor': 'Reconciliation Supervisor',
    'virtualCoder': 'Virtual Coder',
    'MLCoder': 'ML Coder'
  };

  public constructor(
    private accountService: AccountService,
    private alertService: AlertService,
    private authService: AuthService,
    private router: Router) { }

  public ngOnInit(): void {
    if (this.authService.isSessionExpired) {
      this.router.navigateByUrl('/account/login');
    } else if (!this.accountService.IsAdminRole()) {
      this.router.navigateByUrl('/home/actions');
    } else {
      this.loadData();
    }
  }

  public loadData() {
    this.alertService.startLoadingMessage();

    this.accountService.getUsers().subscribe({
      next: users => {
        let userData = users.map(user => {
          user.roles = user.roles.map(role => this._formatRolesDict[role]);
          return user;
        });
        this.userSource = new MatTableDataSource<User>(userData);
        this.userSource.paginator = this.paginator;
        this.userSource.sort = this.sort;
        this.userSource.sortingDataAccessor = (user, property) =>
          typeof user[property] === 'string' ? user[property].toLowerCase() : user[property];
        
      this.alertService.stopLoadingMessage();
    }, error: (error) => {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage(
        'Load Error',
        `Unable to retrieve roles from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
        MessageSeverity.error, error
      );
    }});
  }

  public applyFilter(filterValue: string) {
    this.userSource.filter = filterValue.trim().toLowerCase();
  }

  public editAccount(userId: number) {
    this.router.navigate(['account/edit', userId]);
  }
}
